import type { FC, ReactNode } from "react";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { ScheduleHolidaysContext } from "./scheduleHolidaysContext";
import { useScheduleHolidays } from "./useScheduleHolidays";

/**
 * Loads the holidays of every week the schedule has loaded, once for the page, for every day header, column and
 * shift below it. One range for all of it, so moving between loaded weeks or days asks for nothing new.
 */
export const ScheduleHolidaysProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { hospitalData, chosenDepartment } = useHospitalData();
	const from = hospitalData.weeks.at(0)?.weeklyShifts.at(0)?.days.at(0)?.date;
	const to = hospitalData.weeks.at(-1)?.weeklyShifts.at(0)?.days.at(-1)?.date;
	// No request until the schedule has loaded a week: before that there is no day to mark.
	const scheduleHolidays = useScheduleHolidays(chosenDepartment.department_id, from === undefined || to === undefined ? null : { from, to });
	return <ScheduleHolidaysContext.Provider value={scheduleHolidays}>{children}</ScheduleHolidaysContext.Provider>;
};
